import { useQuery } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { EXPRESS_API } from 'configs/api/expressApi';
import { IExtendedQuickVideo, QuickVideoSortKeys } from './types';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { useToastError } from 'lib/hooks';

export interface IGetQuickVideosParams {
  start?: number;
  limit?: number;
  search?: string;
  order?: PaginationConstants.ASCENDING | PaginationConstants.DESCENDING;
  sortKey?: QuickVideoSortKeys | null;
}

export interface IQuickVideosResponse {
  quickVideos: IExtendedQuickVideo[];
  count: number;
}

const getQuickVideos = async (
  params: IGetQuickVideosParams
): Promise<IQuickVideosResponse> => {
  return (
    await EXPRESS_API.get('quick-videos', {
      params,
    })
  ).data;
};

export const useGetQuickVideos = (params: IGetQuickVideosParams) => {
  const { showError } = useToastError();
  return useQuery(quickVideoKeys.list(params), () => getQuickVideos(params), {
    refetchOnMount: true,
    onError: err => {
      showError(err);
    },
  });
};
